module.exports = __webpack_public_path__ + "img/XHBX.7556dd37.png";